import React, {useState} from "react";
import './styles.css';

function CreateArea(props){
    const [note, setNote] = useState({
        title: "",
        content: ""
    })

    function handleChange(event){
        const {name, value} = event.target;
        setNote(prevNote=>({
            ...prevNote,
            [name]: value
        }))
    }

    function submitNote(event){
        props.onAdd(note);
        setNote({
            title: "",
            content: ""
        })
        event.preventDefault();
    }
    return (
        <div className="container">
            <form>
                <input name="title" onChange={handleChange} value={note.title} placeholder="Title"/>
                <textarea name="content" onChange={handleChange} value={note.content} placeholder="Take a note..." row="3" />
                <button onClick={submitNote}>Add</button>
            </form>
        </div>
    );
}
export default CreateArea